import type GeoJson from './geo-json';
import type GeoJsonWorkplaces from './geo-json-workplaces';
import type GeoJsonLabels from './geo-json-labels';

class FloorPlan {
  id?: string;

  officeId = '';

  storey = 0;

  borderLayer: GeoJson | undefined;

  workplacesLayer: GeoJsonWorkplaces | undefined;

  roomLayer: GeoJson | undefined;

  floorLayer: GeoJson | undefined;

  /**
   * Text and icon annotations. Optional because it is nullable in the database and absent
   * from most stored floorplans — 21 of 70 have one.
   */
  labelLayer: GeoJsonLabels | undefined;
}

export default FloorPlan;
